import React from 'react';
import { COLORS } from '../../theme';

const CORES = {
  neutro: { bg: COLORS.gray, cor: COLORS.textMid },
  sucesso: { bg: '#e4f7ee', cor: '#1a9c5c' },
  perigo: { bg: COLORS.dangerBg, cor: COLORS.danger },
  aviso: { bg: COLORS.warningBg, cor: COLORS.warning },
  info: { bg: COLORS.primaryBg, cor: COLORS.primary }
};

export default function Badge({ tom = 'neutro', children }) {
  const c = CORES[tom] || CORES.neutro;
  return (
    <span style={{
      background: c.bg, color: c.cor, borderRadius: 999, padding: '3px 11px',
      fontSize: 12, fontWeight: 700, display: 'inline-block'
    }}>
      {children}
    </span>
  );
}
